export const themes = {
        "default": {
            "--text-primary": "#ffffff",
            "--text-secondary": "#a3a3a3",
            "--highlight-primary": "#818cf8",
            "--highlight-secondary": "#4f46e5",
            "--base-primary": "#262626",
            "--base-secondary": "#171717"
        },
        
        "light": {
            "--text-primary": "#000000",
            "--text-secondary": "#a3a3a3",
            "--highlight-primary": "#818cf8",
            "--highlight-secondary": "#4f46e5",
            "--base-primary": "#ffffff",
            "--base-secondary": "#cfcfcf"
        },
        
        "mint": {
            "--text-primary": "#9e2a2b",
            "--text-secondary": "#e45556",
            "--highlight-primary": "#124559",
            "--highlight-secondary": "#01161e",
            "--base-primary": "#aec3b0",
            "--base-secondary": "#96b899",
            "--error-primary": "#739b76"
        },

        "creme": {
            "--text-primary": "#994F00",
            "--text-secondary": "#A49A64",
            "--highlight-primary": "#D62828",
            "--highlight-secondary": "#8A1A1A",
            "--base-primary": "#EAE2B7",
            "--base-secondary": "#D5CB99",
            "--error-primary": "#319CFF"
        },

        "forest": {
            "--text-primary": "#D9D0DE",
            "--text-secondary": "#174B38",
            "--highlight-primary": "#A04668",
            "--highlight-secondary": "#D1589A",
            "--base-primary": "#0C1713",
            "--base-secondary": "#080C0A",
            "--error-primary": "#D62828"
        } 
}